import { toast } from '@nile/components';

function errorLink(params) {
  const { code, response = null, message } = params;

  const whitelistedUrl = ['#/login', '#/onboard/billing', '#/forgotpassword'];
  var timerId;
  switch (code) {
    case 278:
      if (response) {
        const resClone = response.clone();
        resClone.json().then((el) => {
          if (el?.redirectURL) {
            window.location.replace(el?.redirectURL);
          }
        });
      }
      break;
    case 561: // SESSION_EXPIRED
    case 570: // No CSRF Token provided or invalid
      toast('info', 'app.common.session.timeout.toast.message');
      if (timerId) {
        return;
      }
      timerId = setTimeout(() => {
        if (code === 570) {
          document.cookie = 'app-csrf' + '=; Path=/; Max-Age=-99999999;';
          document.cookie = 'uitoken' + '=; Path=/; Max-Age=-99999999;';
        }
        window.location.reload();
      }, 6000);
      break;
    case 563:
      if (!whitelistedUrl.some((el) => el === window.location.hash)) {
        window.location.replace('#/onboard/billing');
      }
      break;
    case 564:
      window.location.replace('#/error/subscriptionPaused');
      break;
    case 565:
      window.location.replace('#/error/subscriptionCancelled');
      break;
    case 502:
      window.location.replace('#/error/connectivityIssue');
      break;
    case 503:
      window.location.replace('#/error/serviceUnavailable');
      break;
    case 504:
      window.location.replace('#/error/serviceTimeout');
      break;
    case 520: // SERVICE UNDER MAINTANANCE
      if (response) {
        const resClone = response.clone();
        resClone.json().then((el) => {
          if (el?.error?.includes('Under Maintenance')) {
            if (window.location.hash !== '#/error/underMaintenance') {
              window.localStorage.setItem(
                'previousRoute',
                JSON.stringify({
                  route: window.location.hash,
                  maintenance: true
                })
              );
            }
            setTimeout(() => {
              window.location.replace('#/error/underMaintenance');
            }, 3000);
          }
        });
        if (window.location.hash !== '#/error/underMaintenance') {
          window.localStorage.setItem(
            'previousRoute',
            JSON.stringify({
              route: window.location.hash,
              maintenance: true
            })
          );
        }
        setTimeout(() => {
          window.location.replace('#/error/underMaintenance');
        }, 3000);
      }
      break;
    case 1027:
      window.location.replace('#/error/ssoError?errorCode=1027');
      break;
    case 1028:
      window.location.replace('#/error/ssoError?errorCode=1028');
      break;
    default:
      break;
  }
}

export async function fetchApi(resource, config) {
  let updatedResource = localStorage.getItem('apiDomain') + resource;

  try {
    const response = await fetch(updatedResource, config);
    if (!response.ok) {
      errorLink({ code: response.status, response });
    }
    if (response.ok) {
      if (response?.status === 278) {
        const resClone = response.clone();
        resClone.json().then((el) => {
          if (el?.redirectURL) {
            window.location.replace(el?.redirectURL);
          }
        });
      }
      if (window.location.hash === '#/error/underMaintenance') {
        const route = window.localStorage.getItem('previousRoute');
        const { route: prevRoute } = JSON.parse(route) || {};
        window.location.replace(prevRoute || '#/home');
        setTimeout(() => {
          window.localStorage.removeItem('previousRoute');
        }, 2000);
      }
    }
    return response;
  } catch (err) {
    console.log(err, 'Eror');
  }
}
